import SettingsService from "./services/settings-service";

export const docsHost = process.env.VUE_APP_docsHost ?? "https://respresso.io";

export function getDocsHost(): string {
    const backendUrl = SettingsService.getAppConfig()?.["respresso.public.userdocs.url"];
    if (backendUrl) {
        // console.log("backendUserDocsUrl", backendUrl);
        if (backendUrl.endsWith("/docs")) {
            return backendUrl.replace("/docs", "");
        }
        return backendUrl;
    }
    return docsHost;
}